import { getProposal, update } from 'repositories/proposal.repository';

export const SET_PROPOSAL_EDIT = '[Admin] SET_PROPOSAL_EDIT';
const selectProposal = (data) => ({
  type: SET_PROPOSAL_EDIT,
  payload: data,
});

export const UPDATED_PROPOSAL_EDIT = '[Admin] UPDATE_PROPOSAL_EDIT';
const updatedProposal = (proposal) => ({
  type: UPDATED_PROPOSAL_EDIT,
  payload: proposal,
});

export const findProposal = (uid) => async (dispatch) => {
  const { data } = await getProposal(uid);
  dispatch(selectProposal(data));
  return data;
};

export const saveProposal = (id, params) => (dispatch) => update(id, { ...params, edit: true }).then(() => dispatch(updatedProposal(params)));

export const updateProposalEdit = (params) => (dispatch) => {
  dispatch(updatedProposal(params));
};

export const clearProposal = () => async (dispatch) => {
  dispatch(selectProposal({}));
};
